import React from "react";
import { useTranslation } from "react-i18next";
import Chip from "@/components/ui/chip";
import {
  APPROVAL_STATUS_CHIP,
  SupportTicketApprovalStatus,
} from "../../constants/support-ticket-category";

interface TicketCategoryCellProps {
  category?: number | null;
  approvalStatus?: number | null;
}

/** Talep kategorisi; onaya giden taleplerde altında onay durumu çipi. */
const TicketCategoryCell: React.FC<TicketCategoryCellProps> = ({ category, approvalStatus }) => {
  const { t } = useTranslation();
  if (category == null) return <>—</>;
  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: 4 }}>
      <span>{t(`supportTicketCategory.options.${category}`)}</span>
      {approvalStatus != null && (
        <Chip
          type={APPROVAL_STATUS_CHIP[approvalStatus as SupportTicketApprovalStatus] ?? "default"}
          size="small"
          variant="soft"
        >
          {t(`supportTicketCategory.approvalStatus.${approvalStatus}`)}
        </Chip>
      )}
    </div>
  );
};

export default TicketCategoryCell;
